module.exports = __webpack_public_path__ + "assets/img/certificate-icon.a76daa72.svg";